import React from "react";

const StarRating = ({ rating, maxStars = 5 }) => {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }}>
      {Array.from({ length: maxStars }, (_, index) => (
        <span
          key={index}
          style={{
            fontSize: "24px",
            color: index < rating ? "gold" : "gray",
          }}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default StarRating;
